import { InnerBox } from "@/components/elements/InnerBox";
import { MatchInfoItem } from "@/features/match/components/match-info/MatchInfoItem";
import { TMatchInfo } from "@/features/match/types/MatchInfo";
import { black } from "@/theme/colors";
import { FCC } from "@/types/common";
import { Grid, Stack, Typography } from "@mui/material";

type TMatchBasicInfoProps = {
  defaultValues: Partial<TMatchInfo>;
};

export const MatchBasicInfo: FCC<TMatchBasicInfoProps> = ({ defaultValues }) => {
  return (
    <>
      <InnerBox showDivider={false} padding={3}>
        <Stack alignItems="flex-start">
          <Typography variant="head20Bold" color={black[30]}>
            基本情報
          </Typography>

          <Grid mt={3} container gap={2}>
            <Grid item xs>
              <MatchInfoItem label="会社名" value={defaultValues?.matchName} isShowDivider={false} />
            </Grid>
            <Grid item xs>
              <MatchInfoItem label="紹介事業許可番号" value={defaultValues.licenseNumber} isShowDivider={false} />
            </Grid>
          </Grid>
        </Stack>
      </InnerBox>
    </>
  );
};
